import script from "./LoginForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginForm.vue?vue&type=script&setup=true&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&id=49a153ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a153ce"]])

export default __exports__